import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { NgAppHamburgerMenuComponent } from "./ng-app-hamburger-menu.component";
import { NgAppHamburgerMenuModalComponent } from "./ng-app-hamburger-menu-modal.component";
import { BaseAppHmInlineComponent } from "./ng-app-inline/base-app-hm-inline.component";

import { NgAppHMService } from "./ng-app-hamburger-menu.service";

import { NgWaitModule } from "../ng-shared/ng-components/ng-wait/ng-wait.module";
import { NgUserService } from "../ng-shared/ng-services/ng-user.service";
import { TCITenantMenuServices } from "../ng-tenant/tci-tenant.menu";
import { TciTenantModelService } from "../ng-tenant/tci-tenant.model";
import { NgAppFeatureToggleService } from "../ng-shared/ng-services/ng-app-feature-toggle.service";

import { DialogModule } from "primeng/primeng";

@NgModule({
    imports: [
        CommonModule,
        DialogModule,
        FormsModule,
        NgWaitModule,
    ],
    declarations: [
        NgAppHamburgerMenuComponent,
        NgAppHamburgerMenuModalComponent,
        BaseAppHmInlineComponent
    ],
    exports: [
        NgAppHamburgerMenuComponent,
        NgAppHamburgerMenuModalComponent,
        BaseAppHmInlineComponent
    ],
    providers: [
        TCITenantMenuServices,
        TciTenantModelService,
        NgUserService,
        NgAppFeatureToggleService,
        NgAppHMService
    ]
})
export class NgHamburgerMenuModule {
}
